import { IState } from "../../IState";
import { IUser } from "./IUser";
import { Module } from "vuex";
import { actions } from "./actions";
import { documents } from "./documents";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const user: Module<IUser, IState> = {
  namespaced: true,
  state: {
    currentRole: undefined,
    roles: [],
  },
  modules: {
    documents,
  },
  getters,
  actions,
  mutations,
};
